import { t, applyStaticLabels } from '../i18n.js';
import { nowMarkerRatio } from '../state.js';

export function bindChrome(state, handlers) {
  applyStaticLabels(state.lang);
  updateGlance(state);
  updateTimelineChrome(state);

  document.getElementById('btn-lang').onclick = () => handlers.toggleLang();
  document.getElementById('btn-locate').onclick = () => handlers.locate();
  document.getElementById('btn-play').onclick = () => handlers.togglePlay();

  document.querySelectorAll('[data-layer]').forEach((btn) => {
    btn.onclick = () => handlers.setLayer(btn.dataset.layer);
  });

  const scrubber = document.getElementById('scrubber');
  scrubber.addEventListener('input', () => {
    handlers.seek(Number(scrubber.value));
  });
  scrubber.addEventListener('pointerdown', () => handlers.pause());
}

export function updateLayerButtons(state) {
  document.querySelectorAll('[data-layer]').forEach((btn) => {
    const on = btn.dataset.layer === state.layer;
    btn.classList.toggle('active', on);
    btn.setAttribute('aria-selected', on ? 'true' : 'false');
  });
}

export function updatePlayButton(state) {
  const btn = document.getElementById('btn-play');
  btn.textContent = state.playing ? '❚❚' : '▶';
  btn.setAttribute('aria-label', t(state.lang, state.playing ? 'pause' : 'play'));
}

function formatWhen(iso, lang) {
  if (!iso) return '';
  return new Date(iso).toLocaleString(lang === 'he' ? 'he-IL' : 'en-GB', {
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Asia/Jerusalem',
  });
}

export function updateGlance(state) {
  const title = document.getElementById('glance-title');
  const sub = document.getElementById('glance-sub');
  title.textContent = t(state.lang, 'willItRain');
  if (!state.glance) {
    sub.textContent = t(state.lang, 'glanceLoading');
    return;
  }
  if (state.glance.mode === 'raining') sub.textContent = t(state.lang, 'glanceRaining');
  else if (state.glance.mode === 'soon') {
    sub.textContent = t(state.lang, 'glanceRainSoon', formatWhen(state.glance.whenIso, state.lang));
  } else if (state.glance.mode === 'dry') sub.textContent = t(state.lang, 'glanceDry');
  else sub.textContent = t(state.lang, 'glanceUnknown');
}

export function updateTimelineChrome(state) {
  const scrubber = document.getElementById('scrubber');
  const max = Math.max(0, state.timeline.length - 1);
  scrubber.max = String(max);
  scrubber.value = String(state.index);

  const frame = state.timeline[state.index];
  const label = document.getElementById('time-label');
  const pill = document.getElementById('phase-pill');
  if (frame) {
    const d = new Date(frame.t * 1000);
    label.textContent = d.toLocaleString(state.lang === 'he' ? 'he-IL' : 'en-GB', {
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'Asia/Jerusalem',
    });
    pill.textContent = frame.kind === 'radar' ? t(state.lang, 'radar') : t(state.lang, 'forecast');
    pill.dataset.phase = frame.kind;
  }

  const ratio = nowMarkerRatio(state.timeline, state.nowUnix);
  const firstForecast = state.timeline.findIndex((f) => f.kind === 'forecast');
  const radarShare = firstForecast < 0 ? 1 : firstForecast / Math.max(1, state.timeline.length - 1);
  document.getElementById('seg-radar').style.flexGrow = String(Math.max(0.05, radarShare));
  document.getElementById('seg-forecast').style.flexGrow = String(Math.max(0.05, 1 - radarShare));
  document.getElementById('seg-now').style.insetInlineStart = `calc(${(ratio * 100).toFixed(2)}% - 1px)`;

  const marker = document.getElementById('forecast-marker');
  const markerLabel = document.getElementById('forecast-marker-label');
  if (firstForecast >= 0 && state.timeline.length > 1) {
    const pos = firstForecast / (state.timeline.length - 1);
    marker.hidden = false;
    marker.style.insetInlineStart = `${(pos * 100).toFixed(2)}%`;
    markerLabel.textContent = t(state.lang, 'forecastFromHere');
  } else {
    marker.hidden = true;
  }

  updatePlayButton(state);
  updateLayerButtons(state);
}
